$(document).ready(function(){
  document.addEventListener('variant:change', function(event) {
    var variant = event.detail.variant;
    let var_id = variant.id;
    let metafld_var_id = '';
    $( ".cstm_metafield_btn .cstm_btn_mtfld" ).each(function() {
      metafld_var_id = $(this).attr('data-id');
      $(this).removeClass('cstm_metafield_btn_show');
      
      if(var_id == metafld_var_id){
       $(this).addClass('cstm_metafield_btn_show'); 
      }
      
    });
  });
});